/*
* Project: LegalPlace assistant
* File: src/components/buy/card_modal.js
* Author: Amine Azizi
* Version: 1.0
*/


import React, { Component } from 'react';
import { connect } from 'react-redux';
import MaskedInput from '../misc/masked_input';
import {
  ckPaymentSelect, ckCUpdateCardNumber, ckCUpdateCardExpiration, ckCUpdateCCV, CK_CHECK,
} from '../../redux/actions/checkout_operations';
import { store } from '../../globals';
import lpevents from '../../tracking/lpevents';
import { raiseError, unraiseError } from '../../errors/error';
import { checkingPayment } from '../../redux/actions/loading';
import { getCardClass } from '../utils/credit_card_detect';
import { lpPattern, P_CLOSE_PAYMENT, P_PAY } from '../../tracking/pattern_detector';
import { _lp } from '../../logic/wording';
import lpApp from '../../app/lp_app';
import { HARDCODED_CONVERSION_VALUE_META_IDS } from '../../constants/hardcoded_checkout';

// intiialization of errors payment errors


function initErrors() {
  unraiseError('credit-error');
  unraiseError('credit.number');
  unraiseError('card.exp');
  unraiseError('card.cvc');
  // unraiseError('')
}


class _PaymentModal extends Component {
  constructor(props) {
    super(props);
    this.updateCardNumber = this.updateCardNumber.bind(this);
    this.updateCardExpiration = this.updateCardExpiration.bind(this);
    this.updateCardCCV = this.updateCardCCV.bind(this);
    this.stripeSubscription = this.stripeSubscription.bind(this);
    this.updateCheckBox = this.updateCheckBox.bind(this);

    // do the changes in the card type
    this.state = {
      card_class: 'none',
    };
  }

  componentDidMount() {
    const that = this;
    const a = document.getElementById('checkout-modal1');

    document.getElementById('checkout-modal1').addEventListener('click', (e) => { if ((e.target === a) || (e.target === that.close_btn)) this.props.closeEvent(); lpPattern.trackInPayment(P_CLOSE_PAYMENT); });
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.show && this.props.show) {
      if (this.refs.credit_card_modal) {
        if (document.getElementById('checkout-modal1').firstChild === null || document.getElementById('checkout-modal1').firstChild.children.length === 0) document.getElementById('checkout-modal1').appendChild(this.refs.credit_card_modal);
        document.getElementById('checkout-modal1').classList.add('lp-modal');
        document.getElementById('checkout-modal1').classList.add('tryout-modal');
        document.getElementsByClassName('page-wrap')[0].style.filter = 'blur(5px)';
        document.body.style.overflow = 'hidden';
        lpApp.ops.utils.addModalClassToBody();
      }
    }
    if (prevProps.show && !this.props.show) {
      document.getElementById('checkout-modal1').classList.remove('lp-modal');
      document.getElementById('checkout-modal1').classList.remove('tryout-modal');
      document.getElementsByClassName('page-wrap')[0].style.filter = 'none';
      document.body.style.overflow = 'auto';
      lpApp.ops.utils.removeModalClassToBody();
    }
  }

  componentWillUnmount() {
    if (document.getElementById('checkout-modal1').firstChild) document.getElementById('checkout-modal1').removeChild(document.getElementById('checkout-modal1').firstChild);
    document.getElementById('checkout-modal1').classList.remove('lp-modal');
    document.getElementsByClassName('page-wrap')[0].style.filter = 'none';
    document.body.style.overflow = 'auto';
    lpApp.ops.utils.removeModalClassToBody();
  }

  // TODO: better things.
  updateCardNumber(evt) {
    this.props.updateCardNumber(evt.target.value);
    this.setState({ card_class: getCardClass(evt.target.value) });
  }

  updateCardExpiration(evt) {
    this.props.updateCardExpiration(evt.target.value);
  }

  updateCardCCV(evt) {
    this.props.updateCardCCV(evt.target.value);
  }

  updateCheckBox(evt) {
    console.log('Hello');
    this.props.updateConfirmation(evt.target.checked);
  }

  stripeSubscription() {
    initErrors();
    this.props.loading();
    // tracking.
    lpPattern.trackLastAction(P_PAY);
    lpPattern.sendAndResetTracker();
    window.lp_payment.handleTransaction({
      type: 'abonnement',
      card: {
        number: this.props.card_number,
        cvc: !this.props.card_ccv.includes(' ') ? this.props.card_ccv : this.props.card_ccv.slice(0, 3),
        exp: this.props.card_expiration,
      },
      contract_id: this.props.contract_id,
      pack: 'abonnement', // price issue  I guess
      options: [],
      invoice: lpApp.ops.checkout.isInvoiceActivated() ? lpApp.ops.checkout.getInvoice() : [],
      coupon: this.props.promo_code,
      client_email: this.props.mail,
      revenue: this.totalRevenue(),
      pack_price: this.props.pack_price,
      document_name: lpApp.contractTitle,
      cgv: true,
    }).then((response) => {
      if (response.STATUS === 'SUCCESS') {
        window.localStorage.setItem('purchaseScore', response.purchaseScore);
        window.onbeforeunload = null;
        window.location.href = response.redirect;
      }
      this.props.unloading();
    }).catch(
      (err) => {
        const errorMessage = err && err.length && err[0].message
        lpevents.trackErrorPaymentCheckout(errorMessage)
        // raiseError("global", 10, err.message)
        // test if the the ting is an array
        if (err.length && err.length > 0) {
          err.forEach((idx) => {
            if (idx.hook === 'global') raiseError('credit-error', 10, idx.message);
            else raiseError(idx.hook, 10, idx.message);
          });
        }
        // test if the thing is Error type
        if (err instanceof Error) {
          raiseError('credit-error', 12, err.message);
        }
        this.props.unloading();
      },
    );

    const pack = 'abonnement';
    const eventParams = {};
    eventParams['Chosen price'] = this.props.price[pack];
    eventParams['Total price'] = lpApp.ops.checkout.getTTCPrice();
    eventParams['Chosen pack'] = pack;
    eventParams['Payment method'] = 'Stripe';

    lpevents.track('Asked Payment', eventParams);
    lpevents.trackClickPayment()


    // console.log(this.prepareData())
  }

  totalRevenue = () => {
     // Hardcoded Revenue depend of contract meta ID
     if ( Object.keys(HARDCODED_CONVERSION_VALUE_META_IDS).indexOf(`${lpApp.contractMetaId}`) > -1)
     return HARDCODED_CONVERSION_VALUE_META_IDS[`${lpApp.contractMetaId}`]

     return 0
  }

  closeModal = () => {
    this.props.closeEvent();
    lpPattern.trackInPayment(P_CLOSE_PAYMENT);
  }

  render() {
    return (
      <div ref="credit_card_modal">
        {this.props.show
                    && (
                    <div className="lpm-container">
                      <div ref="close_btn" className="lpm-close icn-x" onClick={this.closeModal}/>
                      <div className="lpm-title">
                        <i className="icn-lock" />
Paiement sécurisé
                      </div>
                      <div className="lpm-content">
                        <div className="chekout-tabs">
                          <div className="checkout-tab active" id="ct-cards">
                            <div className="ct-title">
                              <div className="cp-cards-btn">
                                <div className="cp-cards" />
                              </div>
                            </div>
                            <div className="ct-content">
                              <div id="form-payement">
                                {this.props.credit_error
                                            && (
                                            <div className="alert error">
                                              <span>{this.props.credit_error.message}</span>
                                            </div>
                                            )}
                                <div className={`form-group form-payement__card-number visa${this.state.card_class}${this.props.error_card ? ' error' : ''}`}>
                                  <div className="fg-wrapper">
                                    <label>{_lp('Numéro de carte')}</label>
                                    <MaskedInput mask="!!!! !!!! !!!! !!!!" type="text" className="form-control" autoComplete="cc-number" value={this.props.card_number} onChange={this.updateCardNumber} />
                                    {this.props.error_card && <span className="help-block">{ this.props.error_card.message }</span>}
                                  </div>
                                </div>
                                <div className="row">
                                  <div className={`form-group col-sm-6 form-payement__exp-date ${this.props.error_exp ? ' error' : ''}`}>
                                    <div className="fg-wrapper">
                                      <label>{_lp("Date d'expiration")}</label>
                                      <MaskedInput placeholder={_lp('MM / AA')} mask="!! / !!" type="text" className="form-control" autoComplete="cc-exp" value={this.props.card_expiration} onChange={this.updateCardExpiration} />
                                      {this.props.error_exp && <span className="help-block">{ this.props.error_exp.message }</span>}
                                    </div>
                                  </div>
                                  <div className={`form-group col-sm-6 form-payement__cvc ${this.props.error_cvc ? ' error' : ''}`}>
                                    <div className="fg-wrapper">
                                      <label>{_lp('Crypto (CVC)')}</label>
                                      <MaskedInput mask="!!!!" type="text" className="form-control" autoComplete="cc-csc" value={this.props.card_ccv} onChange={this.updateCardCCV} />
                                      {this.props.error_cvc && <span className="help-block">{ this.props.error_cvc.message }</span>}
                                    </div>
                                  </div>
                                </div>
                                <div className="checkout-payment cp-flexy">
                                  <p className="cp-help-block">{_lp("Après l'essai gratui de 7 jours, vous serez automatiquement débités de 19,90 € chaque mois du fait de la souscription à l'offre LegalPlace Premium. Vous pouvez annuler votre souscription en ligne ou en écrivant à support@legalplace.fr. Aucun prélèvement n'interviendra si vous annulez avant la fin de la période d'essai gratuit.")}</p>
                                  <a className={`btn btn-block btn-primary mobile-right-cta cta-payement${this.props.loading_payment ? ' checking' : ''}`} onClick={this.props.loading_payment ? () => {} : this.stripeSubscription}>
                                    <span className="loading-spin" />
                                    <span className="btn-text">{_lp('Tester 7 jours gratuitement')}</span>
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>

                        </div>
                      </div>
                      <div className="lpm-footer">
                        {_lp("Besoin d'aide? Appelez-nous au ")}
                        <strong>
                          {' '}
                          {lpApp.supportPhone}
                        </strong>
                        {' '}
                      </div>
                    </div>
                    )}
      </div>
    );
  }
}


const mapStateToProps = state => ({
  payment_method: state.checkout_operations.payment_method,
  card_number: state.checkout_operations.credit_card.number,
  card_expiration: state.checkout_operations.credit_card.expiration,
  card_ccv: state.checkout_operations.credit_card.ccv,
  contract_id: state.checkout_operations.contract_id,
  selected_pack: state.checkout_operations.pack,
  price: state.checkout_operations.prices,
  call_chosen: state.checkout_operations.has_call,
  letter_chosen: state.checkout_operations.has_letter,
  // now with the letter informayion
  letter_number: state.checkout_operations.letter.number,
  letter_zip: state.checkout_operations.letter.zip,
  letter_city: state.checkout_operations.letter.city,
  letter_address: state.checkout_operations.letter.address,
  letter_name: state.checkout_operations.letter.name,
  // coupone code
  promo_code: state.checkout_operations.promo_code,
  confirmation: state.checkout_operations.confirm,
  promo_percentage: state.checkout_operations.promo_percentage,
  pack_price: state.checkout_operations.pack === 0
    ? state.checkout_operations.prices.first_price
    : state.checkout_operations.prices.second_price,
  // the errors are here
  credit_error: state.errors.components['credit-error'],
  error_card: state.errors.components['card.number'],
  error_exp: state.errors.components['card.exp'],
  error_cvc: state.errors.components['card.cvc'],
  // payment loading
  loading_payment: state.loading_details.checking_payment,
  // For payment add
  mail: state.account_settings.mail,
});


const mapDispatchToProps = (dispatch) => {
  const l = store.getState().document_state.state;
  if (l === 'new') {
    // dispatch({type: SET_DOCUMENT_ID, doc: d})
  }
  return {
    updatePaymentMethod: (meth) => {
      dispatch(ckPaymentSelect(meth));
    },
    updateCardNumber: (val) => {
      dispatch(ckCUpdateCardNumber(val));
    },
    updateCardExpiration: (val) => {
      dispatch(ckCUpdateCardExpiration(val));
    },
    updateCardCCV: (val) => {
      dispatch(ckCUpdateCCV(val));
    },
    updateConfirmation: (val) => {
      dispatch({ type: CK_CHECK, val });
    },
    loading: () => {
      dispatch(checkingPayment(true));
    },
    unloading: () => {
      dispatch(checkingPayment(false));
    },
  };
};

const PaymentModal = connect(mapStateToProps, mapDispatchToProps)(_PaymentModal);

export default PaymentModal;



// WEBPACK FOOTER //
// ./src/components/buy/payment_modal.js